import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import client from 'api/apiClient';
import { oldGloryBaseUrl } from 'config/apiConfig';
import { getDefaultCompanyId } from 'utils/helpers';

interface RequestMoneyActivityTypes {
    amount: number;
    blocked: boolean;
    createdDate: string;
    currencyCode: string;
    firstName: string;
    imgUrl: string;
    lastName: string;
    myRole: string;
    requestMoneyId: number;
    status: string;
    statusDate: string;
    subject: string;
    username: string;
}

interface typesOfRequestMoney {
    requestActivityList: RequestMoneyActivityTypes[];
    totalRecords: number;
    loading: boolean;
    error: string | null;
    approved: number;
    canceled: number;
    pending: number;
    rejected: number;
}
const initialState: typesOfRequestMoney = {
    requestActivityList: [],
    totalRecords: 0,
    loading: false,
    error: null,
    approved: 0,
    canceled: 0,
    pending: 0,
    rejected: 0,
};
export interface SendRequestPayload {
    nickname: string;
    amount: number | null;
    subject?: string;
    toSva: number | null;
}

interface GetRequestMoneyActivityFilters {
    sortOrder?: string;
    dateFrom: string;
    dateTo: string;
}

export const requestMoney = createAsyncThunk('sendRequest/sendRequestMoeny', async ({ payload }: { payload: SendRequestPayload }) => {
    const response: any = await client.post(`${oldGloryBaseUrl}/request/v2/requestMoney`, { ...payload });
    return response;
});

export const fetchRequestMoneyActivityList = createAsyncThunk<any, GetRequestMoneyActivityFilters>(
    'requestMoneyList/fetchRequestMoneyList',
    async (filters, { getState }) => {
        const state: any = getState();
        const companyId = getDefaultCompanyId(state);
        const { pageNumber, pageSize } = state?.app?.table || {};
        const payload: any = {
            companyId,
            type: 'REQUEST_MONEY',
            sortOrder: 'DSC',
            role: 'ALL',
            pageNumber,
            pageSize,
            ...filters,
        };
        const response: any = await client.post(`${oldGloryBaseUrl}/request/v2/getRequestMoneyActivity`, { ...payload });
        return response;
    }
);
export const fetchRequestMoneyActivityCounts = createAsyncThunk<any>(
    'requestMoneyList/fetchRequestMoneyActivityCounts',
    async (_, { getState }) => {
        const state: any = getState();
        const companyId = getDefaultCompanyId(state);
        const response: any = await client.post(`${oldGloryBaseUrl}/request/v2/getRequestMoneyActivity`, {
            companyId,
            type: 'REQUEST_MONEY',
            sortOrder: 'DSC',
            role: 'ALL',
            pageNumber: 0,
            pageSize: 1,
        });
        return response;
    }
);
const requestMoneyActivitySlice = createSlice({
    name: 'requestMoneyList',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchRequestMoneyActivityList.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchRequestMoneyActivityList.fulfilled, (state, action) => {
            state.loading = false;
            if (!action?.payload) return;
            state.requestActivityList = action?.payload?.activity || [];
            state.totalRecords = action?.payload?.totalRecords;
        });
        builder.addCase(fetchRequestMoneyActivityList.rejected, (state) => {
            state.loading = false;
        });
        builder.addCase(fetchRequestMoneyActivityCounts.fulfilled, (state, action) => {
            if (!action?.payload) return;
            const { pending, rejected, canceled, approved } = action?.payload || {};
            state.pending = pending;
            state.rejected = rejected;
            state.canceled = canceled;
            state.approved = approved;
        });
        builder.addCase(fetchRequestMoneyActivityCounts.rejected, (state) => {
            state.loading = false;
            state.pending = 0;
            state.rejected = 0;
            state.canceled = 0;
            state.approved = 0;
        });
    },
});

export default requestMoneyActivitySlice.reducer;
